import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import PegasusLogo from "@/components/PegasusMark";

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/5 bg-[#0A0A0A]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="mb-6">
              <PegasusLogo className="h-14" />
            </div>
            <p className="text-[#A3A3A3] max-w-md leading-relaxed">
              A design-led construction firm delivering end-to-end civil
              solutions across industrial, commercial, residential, institutional
              and hospitality sectors. Built with clarity. Delivered with care.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">
              Explore
            </div>
            <ul className="space-y-3 text-[#A3A3A3]">
              <li><a href="#about" className="hover:text-white">About</a></li>
              <li><a href="#services" className="hover:text-white">Services</a></li>
              <li><a href="#process" className="hover:text-white">Process</a></li>
              <li><a href="#projects" className="hover:text-white">Projects</a></li>
              <li><a href="#contact" className="hover:text-white">Contact</a></li>
              <li><a href="/admin/login" className="hover:text-white text-[#737373]" data-testid="footer-admin-link">Admin</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">
              Connect
            </div>
            <ul className="space-y-4 text-[#A3A3A3]">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#D4AF37] mt-0.5" />
                <div>
                  <div>+91 90190 35307</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#D4AF37] mt-0.5" />
                <a href="mailto:thepegasusinfraa@gmail.com" className="hover:text-white break-all">
                  thepegasusinfraa@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#D4AF37] mt-0.5" />
                <span>9/39, 21st Main, Nandhini Layout, Bangalore</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#737373]">
          <div>© {new Date().getFullYear()} Pegasus Infra. All rights reserved.</div>
          <div className="font-serif italic text-[#A3A3A3]">
            Built with clarity. Delivered with care.
          </div>
        </div>
      </div>
    </footer>
  );
}
